import { createSelector, createSlice } from "@reduxjs/toolkit";
const INITIAL = [];
const slice = createSlice({
  initialState: INITIAL,
  name: "Wishlist",
  reducers: {
    toggleItemToWishlist: (state, action) => {
      const isExisting = state.some((item) => item.id === action.payload.id);
      if (isExisting) {
        const fiteredItems = state.filter(
          (item) => item.id !== action.payload.id
        );
        return fiteredItems;
      } else {
        state.push(action.payload);
      }
    },
    removeItemFromWishlist: (state, action) => {
      const isExisting = state.some((item) => item.id === action.payload.id);
      if (isExisting) {
        const fiteredItems = state.filter(
          (item) => item.id !== action.payload.id
        );
        return fiteredItems;
      }
    },
  },
});
export const wishlistSelector = createSelector(
  (state) => state.Wishlist,
  (Wishlist) => Wishlist
);
export const wishlistProductSelector = createSelector(
  [(state) => state.Wishlist, (_, id) => id],
  (state, id) => {
    const isExist = state.some((item) => item.id === id);
    return isExist;
  }
);
export default slice.reducer;
export const { toggleItemToWishlist, removeItemFromWishlist } = slice.actions;
